import { jsx as _jsx } from "react/jsx-runtime";
var BOLD_REGEX = /\*\*(.+?)\*\*/g;
var ITALIC_REGEX = /\*(.+?)\*/g;
var MARKDOWN_LINK_REGEX = /\[([^[]+)\](\(.*\))/gm;
var MARKDOWN_LINK_INNER_VALUES_REGEX = /\[([^[]+)\]\((.*)\)/;

/** @internal */
export function toJsx(text) {
  return /*#__PURE__*/_jsx("span", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  });
}

/**
 * Convert text surrounded by double asterisks to strong tags with tw-font-semibold class.
 * @example
 * text: '**Bold text**'
 * formattedText: `<strong class="tw-font-semibold">Bold text</strong>`
 */
export function boldFormatter(text) {
  return text.replace(BOLD_REGEX, function (_, replaced) {
    return "<strong class=\"tw-font-semibold\">".concat(replaced, "</strong>");
  });
}

/**
 * Convert text surrounded by asterisks to em tags with italic class.
 * @example
 * text: '*Italic text*'
 * formattedText: `<em class="italic">Italic text</em>`
 */
export function italicFormatter(text) {
  return text.replace(ITALIC_REGEX, function (_, replaced) {
    return "<em class=\"italic\">".concat(replaced, "</em>");
  });
}

/**
 * Convert links in markdown format to anchor tags.
 * @example
 * text: '[Link label](url)'
 * formattedText: `<a class="link-level4" href="url">Link label</a>`
 */
export var linkFormatter = function linkFormatter(_ref) {
  var text = _ref.text,
    targetBlank = _ref.targetBlank,
    className = _ref.className;
  return text.replace(MARKDOWN_LINK_REGEX, function (linkMatch) {
    var innerValuesMatch = MARKDOWN_LINK_INNER_VALUES_REGEX.exec(linkMatch);
    var label = innerValuesMatch ? innerValuesMatch[1] : '';
    var url = innerValuesMatch ? innerValuesMatch[2] : '';
    return "<a class=\"".concat(className || 'link-level4', "\" href=\"").concat(url, "\"").concat(targetBlank ? ' target="_blank" rel="noopener noreferrer"' : '', ">").concat(label, "</a>");
  });
};